import * as React from 'react';
import styled from 'styled-components';

interface ISwitch {
  active?: boolean;
  toggle?: () => void;
}

export const SwitchButton: React.FC<ISwitch> = ({ active, toggle }) => {
  return (
    <StyledSwitch onClick={toggle}>
      <StyledSwitchDot active={active} />
    </StyledSwitch>
  );
};

const StyledSwitch = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  width: 48px;
  height: 28px;
  padding: 0 3px;
  border-radius: 24px;
  background: #111;
  box-shadow: 1px -1px 0px 0px rgba(255, 255, 255, 0.025);
  cursor: pointer;
`;

const StyledSwitchDot: any = styled.div`
  position: absolute;
  top: 0;
  top: 0;
  bottom: 0;
  left: ${(props: any) => (props.active ? '50%' : 0)};
  margin: auto;
  width: 24px;
  height: 24px;
  background: ${(props: any) => (props.active ? 'rgb(237, 200, 151)' : '#999')};
  border-radius: 50%;
  cursor: pointer;
  transition: background 0.2s ease-in-out;
  transition: left 0.2s ease-in-out, background 0.2s ease-in-out;
  transition: left 0.2s ease-in-out, background 0.2s ease-in-out;
`;
